import { useMotionValue, useMotionTemplate, motion } from "framer-motion";
import { Reveal, Eyebrow } from "./Motion";
import { WhatsAppIcon } from "./Brand";
import { useQuiz } from "../../hooks/QuizContext";

const Spotlight = () => {
  const x = useMotionValue(50);
  const y = useMotionValue(35);
  const bg = useMotionTemplate`radial-gradient(420px circle at ${x}% ${y}%, rgba(255,214,196,0.28), transparent 65%)`;
  const onMove = (e) => {
    const r = e.currentTarget.getBoundingClientRect();
    x.set(((e.clientX - r.left) / r.width) * 100);
    y.set(((e.clientY - r.top) / r.height) * 100);
  };
  return (
    <Reveal className="relative mx-auto w-full max-w-[460px] lg:col-span-5" y={60}>
      <div onMouseMove={onMove} className="group relative aspect-[4/5] overflow-hidden rounded-[2rem] ring-1 ring-[#E9B3A0]/25">
        <img src="/img/smile.webp" alt="Mulher sorridente com a pele lisa e o braço erguido, vestindo top bege" loading="lazy" className="h-full w-full object-cover object-top transition-transform duration-[1.6s] ease-out group-hover:scale-105" />
        <motion.div style={{ background: bg }} className="pointer-events-none absolute inset-0 mix-blend-screen" aria-hidden="true" />
        <div className="absolute inset-x-0 bottom-0 h-1/3 bg-gradient-to-t from-[#2D1C18]/70 to-transparent" aria-hidden="true" />
        <p className="absolute bottom-5 left-6 font-script text-5xl text-[#FAF5EE]">só no Laser Day</p>
      </div>
    </Reveal>
  );
};

const OfferCta = () => {
  const { openQuiz } = useQuiz();
  return (
    <button
      type="button"
      onClick={() => openQuiz("offer")}
      className="btn-rose btn-lg"
      data-testid="offer-cta-whatsapp"
    >
      <WhatsAppIcon className="h-5 w-5" /> Quero minha sessão
    </button>
  );
};

export const Offer = () => (
  <section id="oferta" className="relative overflow-hidden bg-[#2D1C18] py-24 text-[#FAF5EE] sm:py-32" aria-labelledby="oferta-title" data-testid="offer-section">
    <div className="pointer-events-none absolute -right-40 top-10 h-[520px] w-[520px] rounded-full bg-[#B8654F]/25 blur-[120px]" aria-hidden="true" />
    <div className="relative mx-auto grid max-w-[1400px] items-center gap-14 px-5 sm:px-8 lg:grid-cols-12 lg:px-12">
      <Spotlight />
      <div className="lg:col-span-7 lg:pl-10">
        <Reveal><Eyebrow className="text-[#E9B3A0]">Oferta especial Laser Day</Eyebrow></Reveal>
        <Reveal delay={0.1}>
          <h2 id="oferta-title" className="mt-6 inline-block rounded-full bg-gradient-to-b from-[#F6D9CD] to-[#E4A890] px-6 py-2 font-display text-2xl tracking-tight text-[#5A2A1F] sm:text-4xl" data-testid="offer-area">
            VIRILHA COMPLETA
          </h2>
        </Reveal>
        <Reveal delay={0.2} className="mt-6 flex items-end gap-4">
          <span className="pb-4 text-lg font-semibold leading-tight tracking-[0.12em] text-[#F3D9CE] sm:pb-8 sm:text-2xl">POR<br />APENAS</span>
          <p className="price-giant text-metal-light" data-testid="offer-price" aria-label="R$ 49,90">
            <span className="mr-1 align-top text-[0.28em]">R$</span>49<span className="text-[0.55em] align-top">,90</span>
          </p>
        </Reveal>
        <Reveal delay={0.3}>
          <p className="mt-6 max-w-lg text-base leading-relaxed text-[#E8D8D0] sm:text-lg">
            Uma experiência para você conhecer a depilação a laser da Aisla Studio. E no Laser Day, todas as áreas do corpo estão disponíveis — consulte os valores pelo WhatsApp.
          </p>
        </Reveal>
        <Reveal delay={0.4} className="mt-10 flex flex-wrap gap-4">
          <OfferCta />
        </Reveal>
      </div>
    </div>
  </section>
);
